import axios, { AxiosPromise } from 'axios'
import { ImpressaoAcompanhamentoPreNatalInput } from 'view/atendimentos/detail/soap/aside/pre-natal/impressao/ImpressaoAcompanhamentoPreNatalInput'

export class ImpressaoAcompanhamentoPreNatal {
  imprimirAcompanhamentoPreNatal(input: ImpressaoAcompanhamentoPreNatalInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirAcompanhamentoPreNatal', input, { responseType: 'blob' })
  }
}
